const backblazeRegions = [
	"us-west-000",
	"us-west-001",
	"us-west-002",
	"us-west-003",
	"us-west-004",
	"us-west-005",
	"us-west-006",
	"us-west-007",
	"us-west-008",
	"us-west-009",

	"us-east-000",
	"us-east-001",
	"us-east-002",
	"us-east-003",
	"us-east-004",
	"us-east-005",
	"us-east-006",
	"us-east-007",
	"us-east-008",
	"us-east-009",

	"eu-central-000",
	"eu-central-001",
	"eu-central-002",
	"eu-central-003",
	"eu-central-004",
	"eu-central-005",
	"eu-central-006",
	"eu-central-007",
	"eu-central-008",
	"eu-central-009",

	"ca-east-000",
	"ca-east-001",
	"ca-east-002",
	"ca-east-003",
	"ca-east-004",
	"ca-east-005",
	"ca-east-006",
	"ca-east-007",
	"ca-east-008",
	"ca-east-009"
];


const Providers = {
	"Akamai/Linode Object Storage": {
		"url": "https://REGION.linodeobjects.com",
		"useSSL": true,
		"regions": [
			"us-east-1",
			"us-southeast-1",
			"us-central-1",
			"us-west-1",
			"eu-central-1",
			"eu-west-1",
			"ap-south-1",
			"ap-northeast-1"
		],
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"Alibaba Cloud OSS (compat)": {
		"url": "https://oss-REGION.aliyuncs.com",
		"useSSL": true,
		"regions": [
			"eu-central-1",
			"eu-west-1",
			"us-east-1",
			"us-west-1",
			"ap-south-1",
			"ap-southeast-1",
			"ap-southeast-2",
			"ap-northeast-1",
			"cn-hangzhou",
			"cn-shanghai",
			"cn-beijing",
			"cn-shenzhen",
			"cn-hongkong"
		],
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": -1,
		"objLock_mode": [

		],
		"objLock_retainDays": 0
	},
	"Aruba Cloud Object Storage": {
		"url": "https://s3.REGION.cloud.it",
		"useSSL": true,
		"regions": [
			"it1"
		],
		"region": "it1",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"Backblaze B2": {
		"url": "https://s3.REGION.backblazeb2.com",
		"useSSL": true,
		"regions": backblazeRegions,
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"Ceph RGW": {
		"url": "https://rgw.HOST.LAN",
		"useSSL": true,
		"regions": [
			"us-east-1"
		],
		"region": "",
		"useVirtualHosting": false,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"Cloudflare R2": {
		"url": "https://BUCKET.ACCOUNTID.r2.cloudflarestorage.com",
		"useSSL": true,
		"regions": [
			"us-east-1"
		],
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": -1,
		"objLock_mode": [

		],
		"objLock_retainDays": 0
	},
	"Contabo Object Storage": {
		"url": "https://REGION.contabostorage.com",
		"useSSL": true,
		"regions": [
			"eu2",
			"usc1",
			"sin1"
		],
		"region": "eu2",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE"
		],
		"objLock_retainDays": 7
	},
	"Cubbit": {
		"url": "https://s3.cubbit.eu",
		"useSSL": true,
		"regions": [
			"eu-west-1"
		],
		"region": "eu-west-1",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"DigitalOcean Spaces": {
		"url": "https://REGION.digitaloceanspaces.com",
		"useSSL": true,
		"regions": [
			"nyc3",
			"sfo3",
			"ams3",
			"sgp1",
			"fra1"
		],
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": -1,
		"objLock_mode": [

		],
		"objLock_retainDays": 0
	},
	"DreamHost DreamObjects": {
		"url": "https://s3.REGION.dream.io",
		"useSSL": true,
		"regions": [
			"us-east-005"
		],
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": -1,
		"objLock_mode": [

		],
		"objLock_retainDays": 0
	},
	"Exoscale SOS": {
		"url": "https://sos-REGION.exo.io",
		"useSSL": true,
		"regions": [
			"ch-dk-2",
			"ch-gva-2",
			"de-fra-1",
			"de-muc-1",
			"at-vie-1",
			"bg-sof-1"
		],
		"region": "ch-dk-2",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE"
		],
		"objLock_retainDays": 7
	},
	"Filebase": {
		"url": "https://s3.filebase.com",
		"useSSL": true,
		"regions": [
			"us-east-1"
		],
		"region": "us-east-1",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": -1,
		"objLock_mode": [

		],
		"objLock_retainDays": 0
	},
	"Hetzner": {
		"url": "https://REGION.your-objectstorage.com",
		"useSSL": true,
		"regions": [
			"fsn1",
			"nbg1",
			"hel1"
		],
		"region": "fsn1",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"IBM Cloud Object Storage": {
		"url": "https://s3.REGION.cloud-object-storage.appdomain.cloud",
		"useSSL": true,
		"regions": [
			"us-south",
			"us-east",
			"eu-de",
			"eu-gb",
			"jp-tok",
			"au-syd"
		],
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"IDrive e2": {
		"url": "https://REGION.idrivee2.com",
		"useSSL": true,
		"regions": [
			"us-east-1",
			"us-east-2",
			"us-west-1",
			"us-west-2",
			"eu-central-1"
		],
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"IONOS S3 Object Storage": {
		"url": "https://s3.REGION.ionoscloud.com",
		"useSSL": true,
		"regions": [
			"eu-central-1",
			"eu-central-2",
			"eu-south-2",
			"us-east-1",
			"eu-central-3"
		],
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"Leviia Object Storage": {
		"url": "https://s3.leviia.com",
		"useSSL": true,
		"regions": [
			"us-east-1"
		],
		"region": "us-east-1",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": -1,
		"objLock_mode": [

		],
		"objLock_retainDays": 0
	},
	"MinIO": {
		"url": "https://minio.HOST.LAN:9001",
		"useSSL": true,
		"regions": [
			"us-east-1"
		],
		"region": "",
		"useVirtualHosting": false,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"Oracle Object Storage (compat)": {
		"url": "https://compat.objectstorage.REGION.oraclecloud.com",
		"useSSL": true,
		"regions": [
			"us-ashburn-1",
			"us-phoenix-1",
			"eu-frankfurt-1",
			"eu-zurich-1",
			"eu-marseille-1",
			"uk-london-1",
			"me-dubai-1",
			"me-abudhabi-1",
			"sa-saopaulo-1",
			"mx-queretaro-1",
			"ca-toronto-1",
			"ca-montreal-1",
			"ap-mumbai-1",
			"ap-osaka-1",
			"ap-tokyo-1",
			"ap-seoul-1",
			"ap-singapore-1",
			"ap-sydney-1",
			"il-jerusalem-1"
		],
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": -1,
		"objLock_mode": [

		],
		"objLock_retainDays": 0
	},
	"OVHcloud Object Storage": {
		"url": "https://s3.REGION.io.cloud.ovh.net",
		"useSSL": true,
		"regions": [
			"gra",
			"sbg",
			"bhs",
			"rbx",
			"lim"
		],
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"QNAP QuObjects": {
		"url": "https://quobjects.HOST.com",
		"useSSL": true,
		"regions": [
			"us-east-1"
		],
		"region": "",
		"useVirtualHosting": false,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE"
		],
		"objLock_retainDays": 7
	},
	"Scaleway Object Storage": {
		"url": "https://s3.REGION.scw.cloud",
		"useSSL": true,
		"regions": [
			"fr-par",
			"nl-ams",
			"pl-waw"
		],
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"Seagate Lyve Cloud": {
		"url": "https://s3.REGION.lyvecloud.seagate.com",
		"useSSL": true,
		"regions": [
			"us-east-1",
			"us-west-1",
			"eu-west-1",
			"ap-southeast-1"
		],
		"region": "us-east-1",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"Storj (S3 Gateway)": {
		"url": "https://gateway.storjshare.io",
		"useSSL": true,
		"regions": [
			"us-east-1"
		],
		"region": "us-east-1",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"Synology C2 Object Storage": {
		"url": "https://REGION.s3.synologyc2.net",
		"useSSL": true,
		"regions": [
			"eu-001",
			"us-001",
			"tw-001"
		],
		"region": "eu-001",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"Tebi": {
		"url": "https://s3.tebi.io",
		"useSSL": true,
		"regions": [
			"us-east-1"
		],
		"region": "us-east-1",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": -1,
		"objLock_mode": [

		],
		"objLock_retainDays": 0
	},
	"Tencent Cloud COS (compat)": {
		"url": "https://BUCKET.cos.REGION.myqcloud.com",
		"useSSL": true,
		"regions": [
			"ap-guangzhou",
			"ap-shanghai",
			"ap-beijing",
			"ap-chengdu",
			"ap-shenzhen",
			"ap-chongqing",
			"ap-hongkong",
			"ap-singapore",
			"ap-mumbai",
			"ap-tokyo",
			"ap-seoul",
			"na-ashburn",
			"na-siliconvalley",
			"eu-frankfurt"
		],
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": -1,
		"objLock_mode": [

		],
		"objLock_retainDays": 0
	},
	"TrueNAS S3 (MinIO)": {
		"url": "https://truenas.lan:9001",
		"useSSL": true,
		"regions": [
			"us-east-1"
		],
		"region": "",
		"useVirtualHosting": false,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"Vultr Object Storage": {
		"url": "https://REGION.vultrobjects.com",
		"useSSL": true,
		"regions": [
			"ewr1",
			"ams1"
		],
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [

		],
		"objLock_retainDays": 7
	},
	"Wasabi": {
		url: "https://s3.REGION.wasabisys.com",
		useSSL: true,
		regions: [
			// Americas
			"us-east-1", "us-east-2", "us-central-1", "us-west-1", "us-west-2", "ca-central-1",
			// EMEA
			"eu-central-1", "eu-central-2", "eu-west-1", "eu-west-2", "eu-west-3", "eu-south-1",
			// APAC
			"ap-northeast-1", "ap-northeast-2", "ap-southeast-1", "ap-southeast-2"
		],
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	},
	"Yandex Object Storage": {
		"url": "https://storage.yandexcloud.net",
		"useSSL": true,
		"regions": [
			"us-east-1"
		],
		"region": "",
		"useVirtualHosting": true,
		"signatureVersion": 4,
		"objLock_enabled": 0,
		"objLock_mode": [
			"GOVERNANCE",
			"COMPLIANCE"
		],
		"objLock_retainDays": 7
	}
};

// utilities
const _escapeRx = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Costruisce una RegExp dal template URL del provider,
 * sostituendo i placeholder dinamici con pattern adeguati.
 * Usa named groups (region, bucket, accountid, host, lan) quando presenti.
 */
function _buildProviderRegex(templateUrl, regions) {
	// normalizza: togli eventuale slash finale nel template
	let t = templateUrl.replace(/\/+$/, '');
	// marca i placeholder per evitare di "escaparli"
	const markers = {
		REGION: '__PH_REGION__',
		BUCKET: '__PH_BUCKET__',
		ACCOUNTID: '__PH_ACCOUNTID__',
		HOST: '__PH_HOST__',
		LAN: '__PH_LAN__'
	};
	t = t
		.replace(/REGION/g, markers.REGION)
		.replace(/BUCKET/g, markers.BUCKET)
		.replace(/ACCOUNTID/g, markers.ACCOUNTID)
		.replace(/HOST/g, markers.HOST)
		.replace(/LAN/g, markers.LAN);

	// scappa tutto il resto
	t = _escapeRx(t);

	// schema flessibile: http o https
	t = t.replace(/^https:\\\/\\\//i, 'https?:\\/\\/');

	// prepara i pattern per i placeholder
	const regionAlt = (regions && regions.length)
		? '(?<region>' + regions.map(_escapeRx).join('|') + ')'
		: '(?<region>[A-Za-z0-9-]+)';

	const repl = {
		[markers.REGION]: regionAlt,
		[markers.BUCKET]: '(?<bucket>[a-z0-9](?:[a-z0-9.-]{0,61}[a-z0-9])?)',
		[markers.ACCOUNTID]: '(?<accountid>[A-Za-z0-9-]+)',
		[markers.HOST]: '(?<host>[A-Za-z0-9-]+)',
		[markers.LAN]: '(?<lan>[A-Za-z0-9-]+)'
	};

	// re-inserisci i pattern non escapati
	let rxSrc = t;
	Object.entries(repl).forEach(([mk, pat]) => {
		rxSrc = rxSrc.replace(new RegExp(_escapeRx(mk), 'g'), pat);
	});

	// consenti opzionale slash finale
	rxSrc = '^' + rxSrc + '\\/?$';

	return new RegExp(rxSrc, 'i');
}

/**
 * Dato un URL, prova a riconoscere il provider tra le chiavi di S3Helper.
 * Ritorna:
 *  - string (nome provider) se vuoi semplice,
 *  - oppure un oggetto con { provider, groups } se vuoi anche i catturati.
 */
function detectS3Provider(url, { withGroups = false } = {}) {
	if (!url || typeof url !== 'string') return null;
	const candidate = url.trim().replace(/\s+/g, '');

	for (const [providerName, cfg] of Object.entries(Providers)) {
		const rx = _buildProviderRegex(cfg.url, cfg.regions);
		const m = candidate.match(rx);
		if (m) {
			return withGroups ? { provider: providerName, groups: (m.groups || {}) } : providerName;
		}
	}
	return null;
}



export const S3Helper = {

	providers: Providers,

	"detectS3Provider": detectS3Provider

}








//Può servire in futuro, perché le regioni di Backblaze possono cambiare/aumentare-------------------------------------
const prefixes = ["us-west", "us-east", "eu-central", "ca-east"];
const maxIndex = 9; // da 000 a 009

function generateBackblazeRegions(prefixes, maxIndex) {
	const regions = [];

	for (const prefix of prefixes) {
		for (let i = 0; i <= maxIndex; i++) {
			const index = i.toString().padStart(3, "0"); // 0 -> "000", 5 -> "005"
			regions.push(`${prefix}-${index}`);
		}
	}

	return regions;
}

//Potrebbero servire in futuro-------------------------------------------------------------------------
const digitalocean_regions = [
	{
		"codice": "nyc1",
		"nome": "New York 1",
		"localizzazione": "New York, Stati Uniti"
	},
	{
		"codice": "nyc2",
		"nome": "New York 2",
		"localizzazione": "New York, Stati Uniti"
	},
	{
		"codice": "nyc3",
		"nome": "New York 3",
		"localizzazione": "New York, Stati Uniti"
	},
	{
		"codice": "sfo1",
		"nome": "San Francisco 1",
		"localizzazione": "San Francisco, Stati Uniti"
	},
	{
		"codice": "sfo2",
		"nome": "San Francisco 2",
		"localizzazione": "San Francisco, Stati Uniti"
	},
	{
		"codice": "sfo3",
		"nome": "San Francisco 3",
		"localizzazione": "San Francisco, Stati Uniti"
	},
	{
		"codice": "tor1",
		"nome": "Toronto 1",
		"localizzazione": "Toronto, Canada"
	},
	{
		"codice": "lon1",
		"nome": "Londra 1",
		"localizzazione": "Londra, Regno Unito"
	},
	{
		"codice": "fra1",
		"nome": "Francoforte 1",
		"localizzazione": "Francoforte, Germania"
	},
	{
		"codice": "ams2",
		"nome": "Amsterdam 2",
		"localizzazione": "Amsterdam, Paesi Bassi"
	},
	{
		"codice": "ams3",
		"nome": "Amsterdam 3",
		"localizzazione": "Amsterdam, Paesi Bassi"
	},
	{
		"codice": "sgp1",
		"nome": "Singapore 1",
		"localizzazione": "Singapore"
	},
	{
		"codice": "blr1",
		"nome": "Bangalore 1",
		"localizzazione": "Bangalore, India"
	},
	{
		"codice": "syd1",
		"nome": "Sydney 1",
		"localizzazione": "Sydney, Australia"
	}
];

const scaleway_regions = [
	{
		"codice": "fr-par-1",
		"nome": "Parigi 1",
		"localizzazione": "Francia"
	},
	{
		"codice": "fr-par-2",
		"nome": "Parigi 2",
		"localizzazione": "Francia"
	},
	{
		"codice": "fr-par-3",
		"nome": "Parigi 3",
		"localizzazione": "Francia"
	},
	{
		"codice": "nl-ams-1",
		"nome": "Amsterdam 1",
		"localizzazione": "Paesi Bassi"
	},
	{
		"codice": "nl-ams-2",
		"nome": "Amsterdam 2",
		"localizzazione": "Paesi Bassi"
	},
	{
		"codice": "nl-ams-3",
		"nome": "Amsterdam 3",
		"localizzazione": "Paesi Bassi"
	},
	{
		"codice": "pl-waw-1",
		"nome": "Varsavia 1",
		"localizzazione": "Polonia"
	},
	{
		"codice": "pl-waw-2",
		"nome": "Varsavia 2",
		"localizzazione": "Polonia"
	},
	{
		"codice": "pl-waw-3",
		"nome": "Varsavia 3",
		"localizzazione": "Polonia"
	}
];

const wasabi_regions = [
	{
		"codice": "us-east-1",
		"nome": "US East 1 (N. Virginia)",
		"endpoint": "https://s3.wasabisys.com",
		"alias": "https://s3.us-east-1.wasabisys.com"
	},
	{
		"codice": "us-east-2",
		"nome": "US East 2 (N. Virginia)",
		"endpoint": "https://s3.us-east-2.wasabisys.com"
	},
	{
		"codice": "us-central-1",
		"nome": "US Central 1 (Texas)",
		"endpoint": "https://s3.us-central-1.wasabisys.com"
	},
	{
		"codice": "us-west-1",
		"nome": "US West 1 (Oregon)",
		"endpoint": "https://s3.us-west-1.wasabisys.com"
	},
	{
		"codice": "us-west-2",
		"nome": "US West 2 (San Jose)",
		"endpoint": "https://s3.us-west-2.wasabisys.com"
	},
	{
		"codice": "ca-central-1",
		"nome": "CA Central 1 (Toronto)",
		"endpoint": "https://s3.ca-central-1.wasabisys.com"
	},
	{
		"codice": "eu-west-1",
		"nome": "EU West 1 (Londra)",
		"endpoint": "https://s3.eu-west-1.wasabisys.com",
		"alias": "https://s3.uk-1.wasabisys.com"
	},
	{
		"codice": "eu-west-2",
		"nome": "EU West 2 (Parigi)",
		"endpoint": "https://s3.eu-west-2.wasabisys.com",
		"alias": "https://s3.fr-1.wasabisys.com"
	},
	{
		"codice": "eu-west-3",
		"nome": "EU West 3 (Londra)",
		"endpoint": "https://s3.eu-west-3.wasabisys.com",
		"alias": "https://s3.uk-2.wasabisys.com"
	},
	{
		"codice": "eu-central-1",
		"nome": "EU Central 1 (Amsterdam)",
		"endpoint": "https://s3.eu-central-1.wasabisys.com",
		"alias": "https://s3.nl-1.wasabisys.com"
	},
	{
		"codice": "eu-central-2",
		"nome": "EU Central 2 (Francoforte)",
		"endpoint": "https://s3.eu-central-2.wasabisys.com",
		"alias": "https://s3.de-1.wasabisys.com"
	},
	{
		"codice": "eu-south-1",
		"nome": "EU South 1 (Milano)",
		"endpoint": "https://s3.eu-south-1.wasabisys.com",
		"alias": "https://s3.it-1.wasabisys.com"
	},
	{
		"codice": "ap-northeast-1",
		"nome": "AP Northeast 1 (Tokyo)",
		"endpoint": "https://s3.ap-northeast-1.wasabisys.com"
	},
	{
		"codice": "ap-northeast-2",
		"nome": "AP Northeast 2 (Osaka)",
		"endpoint": "https://s3.ap-northeast-2.wasabisys.com"
	},
	{
		"codice": "ap-southeast-1",
		"nome": "AP Southeast 1 (Singapore)",
		"endpoint": "https://s3.ap-southeast-1.wasabisys.com"
	},
	{
		"codice": "ap-southeast-2",
		"nome": "AP Southeast 2 (Sydney)",
		"endpoint": "https://s3.ap-southeast-2.wasabisys.com"
	}
];
